import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/css/index.css'
import wx from 'weixin-js-sdk';
// moment全局中文
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
Vue.config.productionTip = false;
Vue.prototype.$wx = wx

Vue.use(Antd);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
